import React from "react";
import { ISize } from "../../../../classes/interfaces";
import Icon from "../../../../components/ui/Icon";
import { Card, Info, Title, Description, ChevronWrap } from "./DesktopCard.styles";

interface DesktopSizeCardProps {
  size: ISize;
  onOpen: (size: ISize) => void;
}

export default function DesktopSizeCard({ size, onOpen }: DesktopSizeCardProps) {
  // Tamanhos (P/M/G) nao possuem imagem propria, entao nao ha thumbnail aqui —
  // o espaco reservado de "foto" ficava sempre vazio na primeira tela (item 2).
  return (
    <Card onClick={() => onOpen(size)}>
      <Info>
        <Title>{size.name}</Title>
        <Description>
          {size.fractionalMaximum > 1 ? "Escolha até " + size.fractionalMaximum + " sabores" : "Escolha o sabor"}
        </Description>
      </Info>
      <ChevronWrap>
        <Icon name="chevron" size={18} />
      </ChevronWrap>
    </Card>
  );
}
